@if (items.length) {
  <section class="footer-gov">
    <h4 class="footer-gov__title">{{ 'GOVERNMENT_AGENCIES' | translate }}</h4>
    <div #carousel class="carousel">
      <button
        type="button"
        class="carousel__prev"
        (click)="next()"
        [title]="'PREVIOUS_SLIDE' | translate"
        attr.aria-label="{{ 'PREVIOUS_SLIDE' | translate }}"
      ></button>
      <div #carouselItems class="carousel__items">
        <ul
          [@drag]="{
            value: carouselState,
            params: {
              carouselOffset: carouselOffset,
              doubleCarouselOffset: 2 * carouselOffset,
            },
          }"
          (@drag.done)="animEnd($event)"
          class="carousel__ul"
        >
          @for (item of items; track item) {
            <li class="carousel__item">
              <a
                class="carousel__link gov-link"
                [href]="item?.ref.url | translate"
                target="_blank"
                rel="noopener"
              >
                <img
                  [src]="item.image.path"
                  [alt]="item.image.display_name | translate"
                />
              </a>
            </li>
          }
        </ul>
      </div>
      <button
        type="button"
        class="carousel__next"
        (click)="prev()"
        [title]="'NEXT_SLIDE' | translate"
        attr.aria-label="{{ 'NEXT_SLIDE' | translate }}"
      ></button>
    </div>
  </section>
}
